import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';

const PageContainer = styled.div`
  min-height: 100vh;
  background: ${(props) => props.theme.colors.background.dark};
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.fonts.primary};
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 120px 60px 120px;

  @media (max-width: 768px) {
    padding: 120px 24px 120px;
  }
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: 700;
  margin-bottom: 24px;
  line-height: 1.1;
  color: ${(props) => props.theme.colors.text.primary};
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.text.secondary};
  line-height: 1.6;
  margin: 0;
  max-width: 800px;
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(26, 26, 46, 0.95)'
      : 'rgba(255, 255, 255, 0.95)'};
  backdrop-filter: blur(12px);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  padding: 24px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;

  @media (max-width: 768px) {
    padding: 20px 24px;
    flex-direction: column;
    gap: 16px;
  }
`;

const Progress = styled.div`
  color: ${(props) => props.theme.colors.text.secondary};
  font-size: 14px;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const Button = styled.button`
  background: ${(props) =>
    props.primary ? props.theme.colors.primary : 'transparent'};
  border: ${(props) =>
    props.primary ? 'none' : `1px solid ${props.theme.colors.border}`};
  color: ${(props) =>
    props.primary ? '#ffffff' : props.theme.colors.text.primary};
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: ${(props) => props.theme.fonts.primary};

  &:hover {
    transform: translateY(-1px);
    background: ${(props) =>
      props.primary
        ? '#E03E0C'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.05)'};
  }
`;

const RefundPolicies = () => {
  const history = useHistory();
  const location = useLocation();

  // Determine route prefix based on current path
  const { pathname } = location;
  const isTrackAdmin = pathname?.includes('admin-track');
  const isEmployeeAdmin = pathname?.includes('admin-employee');
  const routePrefix = isTrackAdmin
    ? '/admin-track'
    : isEmployeeAdmin
    ? '/admin-employee'
    : '/admin';

  const handleNext = () => {
    history.push(`${routePrefix}/pricing-educator/calculator`);
  };

  const handleBack = () => {
    history.goBack();
  };

  return (
    <EnhancedThemeProvider>
      <PageContainer>
        <ContentWrapper>
          <Title>Refund or Credit Policies</Title>
          <Subtitle>
            Give customers confidence to buy early and lock in sales with clear
            refund and credit policies.
          </Subtitle>

          {/* Content will go here */}
        </ContentWrapper>

        <Footer>
          <Progress>Step 3 of 5</Progress>
          <ButtonGroup>
            <Button onClick={handleBack}>← Back</Button>
            <Button primary onClick={handleNext}>
              Next: Calculate Your Revenue →
            </Button>
          </ButtonGroup>
        </Footer>
      </PageContainer>
    </EnhancedThemeProvider>
  );
};

export default RefundPolicies;
